var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React, { useContext } from "react";
import { RicosNodeContext, RicosNodeContextProvider } from "./../../ricos-context";
const TableRow = ({ node, nodeIndex, RicosNodesRenderer }) => {
  var _a, _b, _c, _d;
  const { parentNode } = useContext(RicosNodeContext);
  const style = { height: ((_c = (_b = (_a = parentNode == null ? void 0 : parentNode.tableData) == null ? void 0 : _a.dimensions) == null ? void 0 : _b.rowsHeight) == null ? void 0 : _c[nodeIndex]) || "auto" };
  return /* @__PURE__ */ React.createElement("tr", { style }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: (_d = node.nodes) != null ? _d : [] })));
};
const TableRowRenderer = (_a) => {
  var _b = _a, { node } = _b, props = __objRest(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(TableRow, __spreadValues({ key: node.id, node }, props));
};
var tableRow_default = TableRowRenderer;
export {
  tableRow_default as default
};
//# sourceMappingURL=tableRow.js.map

import "@wix/ricos/css/plugin-table-viewer.global.css";